import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import globalDataObjReducer from "./slices/globalData-slice";
import currencyReducer from "./slices/currency-slice";
import productReducer from "./slices/product-slice";
import accessTokenReducer from "./slices/authSlice";
import categoryReducer from "./slices/category-slice";
import brandReducer from "./slices/brand-slice";
import productCategoryReducer from "./slices/productCategory-slice";
import selectedProductCategoryReducer from "./slices/selectedProductCategory-slice";
import collectionReducer from "./slices/collection-slice";
import cartReducer from "./slices/cart-slice";
import activeVariantReducer from "./slices/activeVariant-slice";
import activeSlotReducer from "./slices/activeSlot-slice";
import countryReducer from "./slices/country-slice";
import navigateCheckoutReducer from "./slices/navigateCheckout-slice"
import priceRangeReducer from "./slices/priceRange-slice";
import trendingProductsReducer from "./slices/trendingProducts-slice";
import orderReviewsReducer from "./slices/orderReviews-slice";
import storePagesReducer from "./slices/storePages-slice";
import blogsReducer from "./slices/blogs-slice";
import lineitemErrorsReducer from "./slices/lineitemErrors-slice"; 

const persistConfig = {
  key: "flone",
  version: 1.1,
  storage,
  blacklist: ["product"],
};

export const rootReducer = combineReducers({
  globalData: globalDataObjReducer,
  currency: currencyReducer,
  cart: cartReducer,
  product: productReducer,
  category: categoryReducer,
  brand: brandReducer,
  productCategory: productCategoryReducer,
  selectedProductCategory: selectedProductCategoryReducer,
  collection: collectionReducer,
  accessToken: accessTokenReducer,
  activeVariant: activeVariantReducer,
  activeSlot: activeSlotReducer,
  country: countryReducer,
  navigateCheckout : navigateCheckoutReducer,
  priceRange: priceRangeReducer,
  trendingProducts: trendingProductsReducer,
  orderReviews: orderReviewsReducer,
  storePages: storePagesReducer,
  blogs: blogsReducer,
  lineitemErrors: lineitemErrorsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
